<ion-icon [name]="icon" [style.color]="color"></ion-icon>
